import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { Exercise, ExerciseType } from '../types'

export interface ExercisesReducer {
  exercises: Record<number, Exercise[]>
}

const initialState: ExercisesReducer = {
  exercises: {}
}

interface FetchExercisesPayload {
  lessonPlanId: number
  unitId: number
}
export type FetchExercisesAction = PayloadAction<FetchExercisesPayload>
export const FETCH_EXERCISES = createAction<FetchExercisesPayload>('exercises_reducer/fetch_exercises')
interface FetchExercisesSuccessPayload {
  lessonPlanId: number
  exercises: Exercise[]
}
export type FetchExercisesSuccessAction = PayloadAction<FetchExercisesSuccessPayload>
export const FETCH_EXERCISES_SUCCESS = createAction<FetchExercisesSuccessPayload>(
  'exercises_reducer/fetch_exercises_success'
)
export const FETCH_EXERCISES_FAIL = createAction('exercises_reducer/fetch_exercises_fail')

interface UpdateExercisePayload {
  exercise: {
    question: string
    answer: string
    id: number
  }
  lessonPlanId: number
}
export type UpdateExerciseActionType = PayloadAction<UpdateExercisePayload>
export const UPDATE_EXERCISE = createAction<UpdateExercisePayload>('exercises_reducer/update_exercise')
interface UpdateExerciseSuccess {
  exercise: Exercise
  lessonPlanId: number
}
export const UPDATE_EXERCISE_SUCCESS = createAction<UpdateExerciseSuccess>('exercises_reducer/update_exercise_success')
export const UPDATE_EXERCISE_FAIL = createAction('exercises_reducer/update_exercise_fail')

interface DeleteExercisePayload {
  lessonPlanId: number
  exerciseId: number
}
export type DeleteExerciseActionType = PayloadAction<DeleteExercisePayload>
export const DELETE_EXERCISE = createAction<DeleteExercisePayload>('exercises_reducer/delete_exercise')
export const DELETE_EXERCISE_SUCCESS = createAction<DeleteExercisePayload>('exercises_reducer/delete_exercise_success')
export const DELETE_EXERCISE_FAIL = createAction('exercises_reducer/delete_exercise_fail')

interface CreateExercisePayload {
  lessonPlanId: number
  question: string
  answer: string
  question_type: ExerciseType
}
export type CreateExerciseActionType = PayloadAction<CreateExercisePayload>
export const CREATE_EXERCISE = createAction<CreateExercisePayload>('exercises_reducer/create_exercise')
interface CreateExerciseSuccessPayload {
  lessonPlanId: number
  exercise: Exercise
}
export const CREATE_EXERCISE_SUCCESS = createAction<CreateExerciseSuccessPayload>(
  'exercises_reducer/create_exercise_success'
)
export const CREATE_EXERCISE_FAIL = createAction('exercises_reducer/create_exercise_fail')

export const exercisesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_EXERCISES_SUCCESS, (state, action) => {
      return { ...state, exercises: { ...state.exercises, [action.payload.lessonPlanId]: action.payload.exercises } }
    })
    .addCase(UPDATE_EXERCISE_SUCCESS, (state, action) => {
      const currentExercises = state.exercises[action.payload.lessonPlanId]
      const newExercises = currentExercises.map((item) => {
        if (item.id === action.payload.exercise.id) {
          return action.payload.exercise
        } else {
          return item
        }
      })
      return { ...state, exercises: { ...state.exercises, [action.payload.lessonPlanId]: newExercises } }
    })
    .addCase(DELETE_EXERCISE_SUCCESS, (state, action) => {
      const currentExercises = state.exercises[action.payload.lessonPlanId]
      const newExercises = currentExercises.filter((item) => item.id !== action.payload.exerciseId)
      return { ...state, exercises: { ...state.exercises, [action.payload.lessonPlanId]: newExercises } }
    })
    .addCase(CREATE_EXERCISE_SUCCESS, (state, action) => {
      const currentExercises = state.exercises[action.payload.lessonPlanId]
      return {
        ...state,
        exercises: { ...state.exercises, [action.payload.lessonPlanId]: [...currentExercises, action.payload.exercise] }
      }
    })
})
